import { render, staticRenderFns } from "./ImageCreate.view.vue?vue&type=template&id=01f7236b&scoped=true&"
import script from "./ImageCreate.view.vue?vue&type=script&lang=js&"
export * from "./ImageCreate.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7236b",
  null
  
)

export default component.exports